import angular from 'angular'
import { statisticsProduct } from 'redevConfig'
const list = (statisticsProduct && statisticsProduct.list) || ''

const statisticsProductList = list ? require(`redevelopment/statistics/statisticsProduct/${list.templateName}`) : require('./view/statisticsProductList.html')
const statisticsProductListCtrl = list ? require(`redevelopment/statistics/statisticsProduct/${list.controllerName}`) : require('./statisticsProductListCtrl')

export default angular
    .module('app.statisticsProduct', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state('statistics.outputStatistics.statisticsProduct', {
                abstract: true,
                url: '/statisticsProduct',
                template: '<div ui-view></div>',
                title: '商品明细',
                default: 'statistics.outputStatistics.tatisticsProduct.list',
            })
            .state('statistics.outputStatistics.statisticsProduct.list', {
                url: '/list',
                template: statisticsProductList,
                controller: 'statisticsProductListCtrl',
            })
    }])
    .controller('statisticsProductListCtrl', statisticsProductListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsProduct/index.js